import { ONE_MINUTE_MS } from '~/shared/constants/time'

export const TICK_FREQUENCY = ONE_MINUTE_MS
